import { gql } from '@apollo/client';
const GET_SPECIFICATION_PREVIEW_HEADER = gql `
  query GetSpecificationPreviewHeader($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        fancyName
        itemCode
        state
        status {
          id
          namePL
          nameEN
          color
        }
        image
        estimatedCostCalculationBlocked
        confirmationProblems {
          id
          problemType
          blocksEstimatedCostCalculation
          blocksSpecificationConfirmation
          components {
            id
            nodeId
            nodeName
          }
          componentVariants {
            id
            nodeId
            nodeName
          }
        }
        estimatedCostCalculationProblems {
          id
          problemType
          blocksEstimatedCostCalculation
          blocksSpecificationConfirmation
          components {
            id
            nodeId
            nodeName
          }
          componentVariants {
            id
            nodeId
            nodeName
          }
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_PREVIEW_HEADER;
